"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.linkDisplayFormats = void 0;
exports.linkDisplayFormats = [
    "link_only",
    "link_with_favicon",
    "favicon_only",
];
